import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges, Injector, } from "@angular/core";
import { SCFPrivileges, ScfV2Service } from "../../scf-v2.service";
import { EnvironmentService } from "src/app/services/environment/environment.service";
import { TesterToolsService } from "src/app/services/environment/tester-tools.service";
import { FormStatusEnum } from "src/app/common/enumerations/enumerations";
import { DataButtonSignature } from "src/app/common/models/data-button-signature";
import { YesNoDialogComponent } from "src/app/controls/yes-no-dialog/yes-no-dialog.component";
import { utils } from "src/app/modules/libs/utils";
import { WfSignature, WfSignatureResource, WFTaskSignatureResource } from 'src/app/components/workflow/workflow';
import { SCFMaster } from "../../scf";
import { BaseComponent } from "src/app/common/base/base.component";
import { MessagePlaceholder } from "src/app/common/models/placeholder";
import { FormViewState } from "src/app/common/models/form-view-state";


@Component({
  selector: "scf-v2-main-s4",
  templateUrl: "./scf-v2-main-s4.component.html",
  styleUrls: ["./scf-v2-main-s4.component.scss"],
})
export class ScfV2MainS4Component extends BaseComponent implements OnChanges {
  @Input() scfMaster?: SCFMaster | null;
  // @Input() disabled?: boolean;
  @Input() privileges?: SCFPrivileges;
  @Input() status?: FormViewState;

  @Output() changed = new EventEmitter<SCFMaster>();

  disableControls = true;
  disabled?: boolean;
  signatures?: WfSignature[];
  wfSignatures?: WfSignatureResource[];
  wfSignCount?: number;

  constructor(
    private scfService: ScfV2Service,
    private environmentService: EnvironmentService,
    private testerToolsService: TesterToolsService,
    protected override injector: Injector
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.refresh();
  }

  refresh() {
    this.setDisabled();
    this.getValues();
  }

  setDisabled() {
    this.disabled = (
      this.scfMaster?.status !== FormStatusEnum.Active &&
      this.scfMaster?.status !== FormStatusEnum.HoldPoint &&
      this.scfMaster?.status !== FormStatusEnum.AwaitingInspection
    ) || !this.currentUser;
  }

  getValues() {
    this.wfSignatures = [];
    this.signatures = [];
    if (this.scfMaster) {
      this.wfSignCount = this.wfSignatures?.filter((x) => x.signed).length;
      this.createSignatures();
    }
  }

  hasHoldPointTasks() {
    return this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find((x) => x.number == 3)?.wfStepLocals?.some((x) => x.code == "HOLDPOINT");
  }

  hasNoWorkTasks() {
    return this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find((x) => x.number == 3)?.wfStepLocals?.some((x) => x.code == "NO_WORK");
  }

  createSignatures() {
    this.wfSignatures = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find((x) => x.number == 3)?.wfSignatures?.filter((x) => x.wfTaskLocal.wfStepLocal?.code !== "HOLDPOINT" && x.wfTaskLocal.wfStepLocal?.code !== "NO_WORK");
    if (this.wfSignatures) {
      for (const t of this.wfSignatures) {
        const signature: WfSignature = {
          id: t.id,
          approveActionId: t.approveID,
          unapproveActionId: t.unapproveID,
          disapproveActionId: t.disapproveID,
          amendmentId: t.amendmentID,
          code: t.code,
          name: t.titleBefore,
          roles: t.roles.map((r) => r?.id),
          roleCodes: t.roles.sort((a, b) => utils.sort(a?.code, b?.code)).map((r) => r?.code).join("/"),
          disabled: !t.enabled || this.disabled || t.disabled,
          testSignReady: t.testSignReady,
          sectionNumber: 3,
          approvedBy: t.signedBy,
          approved: t.signed,
          approvedOn: t.signedOn,
          approveAction: this.scfMaster?.status != FormStatusEnum.HoldPoint && ((t.approveEnabled && t.code != "SHIELDINGINSPECTED2") ||
            (t.approveEnabled &&
              t.approveID > 0 &&
              t.code == "SHIELDINGINSPECTED2" &&
              this.scfMaster?.status == FormStatusEnum.AwaitingInspection && this.hasRoles(t.roles))),
          unapproveAction: (t.unapproveEnabled && t.code != 'WORKCOMPLETE') || (t.unapproveEnabled && t.code == 'WORKCOMPLETE' && this.signCount() == 1),
          disapproveAction:
            t.disapproveEnabled ||
            (t.code == "SHIELDINGINSPECTED2" &&
              t.disapproveID != 0 &&
              !this.disabled &&
              this.scfMaster?.status == FormStatusEnum.AwaitingInspection && this.hasRoles(t.roles)
            ),
          amendment: t.amendmentEnabled,
          required: t.required,
          taskId: t.taskID,
          value: t.value,
          enabled: t.enabled,
          warning: false
        };
        this.wfSignCount = this.signCount();
        this.signatures?.push(signature);
      }
    }
  }

  signCount() {
    let count = 0;
    if (this.wfSignatures) {
      this.wfSignatures.map((t) => {
        if (t?.signed) {
          count++;
        }
      });
    }
    return count;
  }

  approve(s: WfSignature) {
    let status = this.scfMaster?.status;

    const wfTaskSignature: WFTaskSignatureResource = {
      taskId: s.taskId,
      actionId: s.approveActionId,
    };

    if (this.signCount() + 1 === this.wfSignatures?.length) {
      //  Active => WorkComplete
      status = FormStatusEnum.WorkCompleted;
      const confirm = this.dialog.open(YesNoDialogComponent, {
        width: "500px",
        data: {
          message: this.getMessage("toWorkCompleteWarning")
            ?.description,
          icon: "warn",
        },
      });
      confirm
        .afterClosed()
        .toPromise()
        .then((data) => {
          if (data) {
            this.scfService
              .sign(wfTaskSignature)
              .toPromise()
              .then((res) => {
                if (this.scfMaster?.status !== status) {
                  this.alert.message("formStateChanged", [
                    new MessagePlaceholder("{serialNo}", this.scfMaster?.serialNo),
                    new MessagePlaceholder("{status}", "Work Completed"),
                  ]
                  );
                }
              })
              .catch((error) => {
                console.log(error);
                this.alert.defaultError();
              });
          } else {
            this.getValues();
          }
        });
    } else {
      this.scfService
        .sign(wfTaskSignature)
        .toPromise()
        .then((res) => {
        })
        .catch((error) => {
          console.log(error);
          this.alert.defaultError();
        });
    }
  }

  /**
   * Whether the tester-only "auto-sign as role" tooling should be shown.
   * Gated defensively: only on non-production builds AND for System Administrators,
   * mirroring scf-v2-main-s1/s3's showTestTools so it can never surface in production.
   */
  get showTestTools(): boolean {
    return !this.environmentService.isProduction() && this.isSA() && this.testerToolsService.enabled;
  }

  /**
   * Tester convenience: whether to offer the "Tester Approve" button for a Work Complete
   * signature. Mirrors scf-v2-main-s3's canTestSign for the Work Complete section (section 3).
   *
   * The button appears on the one signature whose turn it currently is — the backend sets
   * `testSignReady` (a role/user-independent readiness flag derived from the workflow's own
   * step-active ordering, so signatures that aren't reachable yet stay off) — but only when the
   * logged-in SA cannot actually complete the approval themselves. "Cannot complete it" covers
   * both the no-role case (no Approve button) and the has-role-but-greyed case. The server-side
   * TestSign resolves the appropriate signer in either case.
   *
   * The button hides only when the SA can genuinely sign it themselves — i.e. the real Approve
   * button is both shown (`approveAction`) and enabled (`!disabled`).
   */
  canTestSign(s: WfSignature): boolean {
    return (
      this.showTestTools &&
      s.sectionNumber === 3 &&
      !!s.testSignReady &&
      !this.disabled &&
      !!s.approveActionId &&
      !(s.approveAction && !s.disabled)
    );
  }

  /**
   * Tester tooling (non-production): applies this Work Complete signature on behalf of the
   * appropriate user (the first holder of one of the signature's roles) via the non-prod,
   * SA-gated TestSign endpoint. The signer is resolved server-side. The SignalR refresh that
   * follows reloads the form for all open clients; signing the final outstanding signature in
   * the section advances the form (Active -> Work Completed).
   */
  async testSign(s: WfSignature) {
    if (!this.canTestSign(s)) return;
    // Confirmation popup intentionally disabled for now — the tooltip on the
    // "Tester Approve" button plus the non-prod/SA guards are sufficient. Kept
    // (commented) so it can be re-enabled easily if we want the prompt back.
    // const confirm = this.dialog.open(YesNoDialogComponent, {
    //   width: '450px',
    //   data: {
    //     message:
    //       'Tester tool (non-production): apply the "' +
    //       (s.name ?? 'this') +
    //       '" signature as the appropriate user (' +
    //       (s.roleCodes || 'the required role') +
    //       ')? This signs the form as a different user.',
    //   },
    // });
    // const ok = await confirm.afterClosed().toPromise();
    // if (!ok) return;

    // Note: unlike Work Approvals (section 2 -> Active), the Work Complete transition has no
    // OLog post in the real approve() flow — its only final-signature side effect is the
    // "form state changed" announcement, replicated below. Any backend-driven side effects of
    // completing the work fire identically here because testSign reuses the same SignTask path.
    const isFinal = this.signCount() + 1 === this.wfSignatures?.length;
    const prevStatus = this.scfMaster?.status;

    const wfTaskSignature: WFTaskSignatureResource = {
      taskId: s.taskId,
      actionId: s.approveActionId,
    };
    this.scfService.testSign(wfTaskSignature).toPromise().then(
      (data) => {
        this.scfMaster = data;
        // Mirror approve(): announce the Active -> Work Completed transition on the final signature.
        if (
          isFinal &&
          prevStatus !== FormStatusEnum.WorkCompleted &&
          this.scfMaster?.status === FormStatusEnum.WorkCompleted
        ) {
          this.alert.message("formStateChanged", [
            new MessagePlaceholder("{serialNo}", this.scfMaster?.serialNo),
            new MessagePlaceholder("{status}", "Work Completed"),
          ]);
        }
        this.refresh();
      },
      (error) => {
        console.log(error);
        this.alert.defaultError();
      }
    );
  }

  disapprove(s: WfSignature, data: DataButtonSignature) {
    const wfTaskSignature: WFTaskSignatureResource = {
      taskId: s.taskId,
      actionId: s.disapproveActionId,
      reason: data.text,
    };
    this.scfService
      .sign(wfTaskSignature)
      .toPromise()
      .then(
        (res) => {
        },
        (error) => {
          console.log(error);
          this.alert.defaultError();
        }
      );
  }

  unapprove(s: WfSignature) {
    const wfTaskSignature: WFTaskSignatureResource = {
      taskId: s.taskId,
      actionId: s.unapproveActionId,
    };
    this.scfService
      .sign(wfTaskSignature)
      .toPromise()
      .catch(
        (error) => {
          console.log(error);
          this.alert.defaultError();
        }
      );
  }

}
